import { getToken } from "../../services/HttpService";


export const putNoRequiredMicrodata = async (model) => {

    /* const endPoint = `https://${types.apiID}.execute-api.us-east-1.amazonaws.com/microdatarecord`;  */
    const endPoint = `${process.env.REACT_APP_API}/microdatarecord`; 
    const response = await getToken();

    const resp = await fetch(endPoint,{
        headers: {
            Authorization: `Bearer ${response.token}`,
            "Content-Type": "application/json"
        },
        method: 'PUT',
        body: JSON.stringify(model)
    })

    return await resp.json();
}
